import { render, staticRenderFns } from "./SetMainPanel.vue?vue&type=template&id=146a9c42&scoped=true&"
import script from "./SetMainPanel.vue?vue&type=script&lang=js&"
export * from "./SetMainPanel.vue?vue&type=script&lang=js&"
import style0 from "./SetMainPanel.vue?vue&type=style&index=0&id=146a9c42&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146a9c42",
  null
  
)

export default component.exports